import { GetPaginatedResources } from '../actions/resources';

export default (store) => {
    store.dispatch(GetPaginatedResources());
};
